import React from 'react';
import RenderIf from "../../../../core/components/render-if";
import {getActiveOrganisation} from "../../../Auth/services/organisationService";

function RenderIfHasGamification({children,fallback = null}) {
    const activeOrganisation = getActiveOrganisation()
    /**
     * 71 mohiti
     * 1619 haqir
     * 2270 jet
     * 1746 daneshi
     */
    return (
        <RenderIf cond={[71, 1619, 2270, 1746].includes(activeOrganisation?.organization?.id)} falsyElement={fallback}>
            {children}
        </RenderIf>
    );
}

export default RenderIfHasGamification;